import React from 'react';

import i18n from 'i18next';
import IframeResizer from 'iframe-resizer-react';

import { Header } from 'uikit/layouts';
import { Loading } from 'uikit/loaders';
import { Typo } from 'uikit/content';
import { Filters, ListEmpty } from '@/exceed';

// import InsightsDashboardFooter from './insightsDashboardFooter';
import InsightsDashboardTimestamp from './insightsDashboardTimestamp';

import styles from '../styles/insightsDashboard.module.scss';

const InsightsDashboard = ({
  description,
  filters,
  filterSelection,
  isEmpty,
  isLoading,
  // nextDashboard,
  onClearButtonClick,
  onFilterChange,
  // onFooterClick,
  timestamp,
  title,
  url,
}) => (
  <>
    <Header
      className={styles.header}
      leftColumn={
        <Typo className={styles.title} element="h5" weight="medium">
          {title}
        </Typo>
      }
      rightColumn={
        <Filters
          isDisabled={isEmpty}
          filters={filters}
          selection={filterSelection}
          onClearButtonClick={onClearButtonClick}
          onSelectionUpdate={onFilterChange}
        />
      }
    />
    {isEmpty ? (
      <ListEmpty
        className={styles.empty}
        body={i18n.t('insights-dashboard-empty-body')}
        title={i18n.t('insights-dashboard-empty-title')}
      />
    ) : (
      <>
        {description && (
          <Typo className={styles.body} color="secondary">
            {description}
          </Typo>
        )}
        {isLoading ? (
          <Loading className={styles.loader} />
        ) : (
          <IframeResizer className={styles.iframe} src={url} />
        )}
      </>
    )}
    <InsightsDashboardTimestamp isEmpty={isEmpty} timestamp={timestamp} />
    {/* {nextDashboard && (
      <InsightsDashboardFooter nextType={nextDashboard.type} onClick={onFooterClick} />
    )} */}
  </>
);

export default React.memo(InsightsDashboard);
